import request from '@/utils/request'

export function getActivityGiveList(data) {
    return request({
        url: '/backend/activity/getActivityGiveList',
        method: 'post',
        data: data
    })
}
export function delActivityGiveLog(data) {
    return request({
        url: '/backend/activity/delActivityGiveLog',
        method: 'post',
        data: data
    })
}
export function handleInfoGive(data) {
    return request({
        url: '/backend/activity/handleInfoGive',
        method: 'post',
        data: data
    })
}
export function revokeGiveCourse(data) {
    return request({
        url: '/backend/activity/revokeGiveCourse',
        method: 'post',
        data: data
    })
}
